export const rolesData = {
    'entitlements': [
        {
            'entitlementIdentifer': '100',
            'allowRead': true,
            'allowAdd': false, 'allowUpdate': false, 'allowCopy': false, 'allowDelete': false, 'allowPrint': false
        },
        {
            'entitlementIdentifer': '101',
            'allowRead': true,
            'allowAdd': false, 'allowUpdate': true, 'allowCopy': false, 'allowDelete': false, 'allowPrint': false
        },
        {
            'entitlementIdentifer': '121',
            'allowRead': true,
            'allowAdd': false, 'allowUpdate': false, 'allowCopy': false, 'allowDelete': false, 'allowPrint': false
        },
        {
            'entitlementIdentifer': '259',
            'allowRead': true,
            'allowAdd': false, 'allowUpdate': false, 'allowCopy': false, 'allowDelete': false, 'allowPrint': false
        },
        {
            'entitlementIdentifer': '258',
            'allowRead': true, 'allowUpdate': false,
            'allowAdd': false, 'allowCopy': false, 'allowDelete': false, 'allowPrint': false
        },
        {
            'entitlementIdentifer': '101',
            'allowRead': true, 'allowUpdate': false, 'allowAdd': false, 'allowCopy': false, 'allowDelete': false, 'allowPrint': false
        },
        {
            'entitlementIdentifer': '102',
            'allowRead': true, 'allowUpdate': false, 'allowAdd': false, 'allowCopy': false, 'allowDelete': false, 'allowPrint': false
        },
        {
            'entitlementIdentifer': '105',
            'allowRead': true, 'allowUpdate': false, 'allowAdd': false, 'allowCopy': false, 'allowDelete': false, 'allowPrint': false
        },
        {
            'entitlementIdentifer': '106',
            'allowRead': true, 'allowUpdate': false, 'allowAdd': false, 'allowCopy': false, 'allowDelete': false, 'allowPrint': false
        },
        {
            'entitlementIdentifer': '107',
            'allowRead': true, 'allowUpdate': false, 'allowAdd': false, 'allowCopy': false, 'allowDelete': false, 'allowPrint': false
        },
        {
            'entitlementIdentifer': '123',
            'allowRead': true, 'allowUpdate': false, 'allowAdd': false, 'allowCopy': false, 'allowDelete': false, 'allowPrint': false
        },
        {
            'entitlementIdentifer': 'BAD',
            'allowRead': false, 'allowUpdate': false, 'allowAdd': false, 'allowCopy': false, 'allowDelete': false, 'allowPrint': false
        }
    ]
};
